<template>
  <mj-modal-wrapper>
    <mj-modal-head>
      <h2 class="font-semibold text-white text-2xl">
        Möchtest du {{ params.event.name }} wirklich löschen?
      </h2>
      <small class="text-indigo-300">
        Keine Sorge, deine Spotify Playlist wird nicht mit gelöscht.
      </small>
    </mj-modal-head>
    <mj-modal-content>
      <div class="event-delete-modal__buttons mx-auto w-3/5 flex justify-between">
        <div class="close">
          <mj-button
            class="btn-naked"
            @click="onClose"
          >
            Abbrechen
          </mj-button>
        </div>
        <div class="submit">
          <mj-button
            class="btn-primary inline-flex"
            :is-busy="isBusy"
            @click="onSubmit"
          >
            Löschen
          </mj-button>
        </div>
      </div>
    </mj-modal-content>
  </mj-modal-wrapper>
</template>

<script>
import { mapActions } from 'vuex';
import ModalWrapper from '@/components/ui/general/modal/ModalWrapper.vue';
import ModalHead from '@/components/ui/general/modal/ModalHead.vue';
import ModalContent from '@/components/ui/general/modal/ModalContent.vue';

export default {

  name: 'EventDeleteModal',

  components: {
    'mj-modal-wrapper': ModalWrapper,
    'mj-modal-head': ModalHead,
    'mj-modal-content': ModalContent,
  },

  props: {
    params: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      isBusy: false,
    };
  },

  methods: {
    ...mapActions(['deleteEvent']),

    onSubmit() {
      this.isBusy = true;
      this.deleteEvent(this.params.event.id)
        .then(() => {
          this.$router.push({ name: 'event.overview' });
          this.onClose();
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => { this.isBusy = false; });
    },


    onClose() {
      this.isBusy = false;
      this.$modal.hide('root-modal');
    },

  },

};
</script>
